export default {
  'primary': '#DA291C',
  'secondary': '#DAAA00',
  'accent': '#DA291C'
}
